import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { Grid, TextField } from '@material-ui/core';
import FilterListIcon from '@material-ui/icons/FilterList';
import Autocomplete from '@material-ui/lab/Autocomplete';

import { Search } from './components';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'left',
    justifyContent: 'left',
    flexWrap: 'wrap'
  },
  search: {
    flexGrow: 1,

  },
  filterButton: {
    marginLeft: 'auto'
  },
  filterIcon: {
    marginRight: theme.spacing(1)
  }
}));

const LiveFilter = props => {
  const { onFilter,masters,hintname, onSearch, className, ...rest } = props;

  const classes = useStyles();

  const [openFilter, setOpenFilter] = useState(false);


  const [values, setValues] = useState({
  });
  const handleoptionchange = type => (event, value) => {
    let selectedvalues = [];
    if(value)
    {
      value.map(element => {
        selectedvalues.push(element.id)
      })
    }
    setValues(values => ({
      ...values,
      [type]: value
    }));

    props.onSearch(type,selectedvalues)
  }

  const handleFilterOpen = () => {
    setOpenFilter(true);
  };

  const handleFilterClose = () => {
    setOpenFilter(false);

  };

  return (
    <Grid
      {...rest}
      className={clsx(classes.root, className)}
      container
      spacing={3}
    >
      
      {/* <Grid item xs={3}>
        {masters?.commodity &&    <Autocomplete

      options={masters?.commodity}
      getOptionLabel= {(option) => option.name}
                    multiple
                    id="combo-box-demo"
                    margin="dense"
                    fullWidth
                    value={values.language}
                    onChange={handleoptionchange('commodity')}
                    renderInput={(params) => <TextField {...params} label={"Commodity"} fullWidth margin="dense" variant="outlined" />}
                  /> }
      </Grid> */}
      {/* <Grid item xs={3}>
      <Autocomplete

options={[
  {
"id":1,
"name": "Edible Oil",
"imageurl":"http://128.199.83.45/moogambika_dev/images/Commodity/edible%20oil%20/8a5bd2d5d42062ced224c8658b316093_20140107021219759.jpg",
"status": true
},
{
"id":2,
"name": "Sago",
"imageurl":"http://128.199.83.45/moogambika_dev/images/Commodity/Sago/55bb5bfabcdbf0f9b1277b8e9667846a_6818252644.jpg",
"status": true


},
{
"id":3,
"name": "Pulses",
"imageurl":"http://128.199.83.45/moogambika_dev/images/Commodity/Pulses/b39110cc356f8ee39b37c80774feaec6_y.jpg",
"status": false
},
{
"id":4,
"name": "Kirana",
"imageurl":"http://128.199.83.45/moogambika_dev/images/Commodity/Kirana/6870ca75fadf4af712a6edce4ffeccd5_spices-1.png",
"status": true
},
{
"id":11,
"name": "Coconuts",
"imageurl":"http://128.199.83.45/moogambika_dev/images/Commodity/Coconuts/d687a2f6c84caad6026f6b2d85f15605_ytyu45.jpg",
"status": true
},
{
"id":5,
"name": "Spices",
"imageurl":"http://128.199.83.45/moogambika_dev/images/Commodity/Spices/5e4875a4e65c1f626c0a720491b26e12_spices.jpg",
"status": true
},
{
"id":6,
"name": "Rice",
"imageurl":"http://128.199.83.45/moogambika_dev/images/Commodity/Rice/9e646386eafe6bec6879abecdb1c9136_sonamasoori.jpg",
"status": true
},
{
"id":7,
"name": "Sugar",
"imageurl":"http://128.199.83.45/moogambika_dev/images/Commodity/Sugar/26e9148582319f26f7056552ca47b46a_Wooden Sugar scoop copy.jpg",
"status": true
},
{
"id":8,
"name": "Turmaric",
"imageurl":"http://128.199.83.45/moogambika_dev/images/Commodity/Turmeric/b390466e2f20f12c175105496d58b7df_15oii.jpg",
"status": true
},
{
"id":9,
"name": "Dryfruits",
"imageurl":"http://128.199.83.45/moogambika_dev/images/Commodity/Sago/55bb5bfabcdbf0f9b1277b8e9667846a_6818252644.jpg",
"status": true
},
{
"id":10,
"name": "Gnseed",
"imageurl":"http://128.199.83.45/moogambika_dev/images/Commodity/Dryfruits/575a3863bc0049bba4261bb3b9987793_q copy.jpg",
"status": true
}
]}
getOptionLabel= {(option) => option.name}
              multiple
              id="combo-box-demo"
              margin="dense"
              fullWidth
              value={values.language}
               onChange={handleoptionchange('commodity')}
              renderInput={(params) => <TextField {...params} label={"Commodity"} fullWidth margin="dense" variant="outlined" />}
            /> 
      </Grid> */}
      {/* <Grid item xs={3}>
        {masters?.languages &&  <Autocomplete
                  multiple
                  id="combo-box-demo"
                  options={masters?.languages}
                  margin="dense"
                  fullWidth
                  value={values.language}
                  onChange={handleoptionchange('language')}
                  getOptionLabel={(option) => option.name}
                  renderInput={(params) => <TextField {...params} label={"Languages"} fullWidth margin="dense" variant="outlined" />}
                /> }
            </Grid>  */}
            <Grid item xs={6}>
        <Search
        hintname={hintname}
          className={classes.search}
          onSearch={onSearch}
        />
      </Grid>
    </Grid>
  );
};

LiveFilter.propTypes = {
  className: PropTypes.string,
  onFilter: PropTypes.func,
  onSearch: PropTypes.func
};

export default LiveFilter;
